import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ManutencaoHelperService {

  constructor(private http: HttpClient) { }

  public getAllHelpers(): Observable<any[]> {
    return this.http.get<any[]>(
      `Help/ListarModulos`, httpOptions);
  };

  public carregarFuncionalidades(idModulo: number): Observable<any[]> {
    return this.http.get<any[]>(
      `Help/CarregarFuncionalidades/${idModulo}`, httpOptions);
  };

  public atualizaListaFuncionalidades(idModulo: number, obj: any): Observable<any[]> {
    return this.http.put<any[]>(
      `Help/Atualizar/${idModulo}`, obj, httpOptions);
  }

}
